import {
  Box,
  Button,
  Card,
  Icon,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Stack,
  useMediaQuery,
  useTheme
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useContext, useState } from "react";
import Pageheader from "../common/Pageheader";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  setLogindata,
  setMultiLanguageCode,
  setMultiLanguageData,
  setSelectedAppPermissions,
  setSelectedClientdata
} from "../../redux/actions/actions";
import { English } from "../../constant/EnglishFallback";
import {
  GET_APP_LABELS_LANGUAGES_DETAILS,
  TOGGLE_USER_TRANSLATOR_MASSAGE
} from "../../constant/Apipath";
import { Getrequestcall } from "../../request/Getrequest";
// import { LanguageContext } from "../../connect/LanguageContext";
import ChangePassword from "./ChangePassword";
import { SendFeedbackModal } from "./SendFeedbackModal";

import FacebookLogo from "../../assets/images/facebook.png";
import InstagramLogo from "../../assets/images/instagram.png";
import LinkedInLogo from "../../assets/images/linkedin.png";
import TwitterLogo from "../../assets/images/twitter.png";
import BuildIdLogo from "../../assets/images/build_id_logo.png";
import packageJson from "../../../package.json";
import LanguageSettings from "./LanguageSettings";
import NotificationSettingModal from "./NotificationSettingModal";
const socialIcons = [
  { img: FacebookLogo, link: "https://www.facebook.com/profile.php?id=100083197813565" },
  { img: InstagramLogo, link: "https://www.instagram.com/mybuilderid/" },
  { img: LinkedInLogo, link: "https://www.linkedin.com/company/my-builder-id" },
  { img: TwitterLogo, link: "https://twitter.com/mybuilderid" }
];

export default function Settings() {
  const [confirmChangePasswordModal, setConfirmChangePasswordModal] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);
  const [languageSettingsModal, setLanguageSettingsModal] = useState(false);
  const [openProcessModal, setOpenProcessModal] = useState(false);
  const [openSendFeedbackModal, setOpenSendFeedbackModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { loginData } = useSelector((state) => state.main);
  const { multiLanguageData } = useSelector((state) => state?.main);
  const [languageName, setLanguageName] = useState("English");
  const [languageCode, setLanguageCode] = useState("en");
  const [languageList, setLanguageList] = useState([]);

  // const { setLanguageCode } = useContext(LanguageContext);

  const LanguageData = multiLanguageData?.Settings || {};
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    TEXT_SETTINGS = English.Settings.TEXT_SETTINGS,
    TEXT_TERMS_AND_CONDITIONS = English.Settings.TEXT_TERMS_AND_CONDITIONS,
    TEXT_LANGUAGE_SETTINGS = English.Settings.TEXT_LANGUAGE_SETTINGS,
    BUTTON_SEND_FEEDBACK = English.Settings.BUTTON_SEND_FEEDBACK,
    TEXT_CHANGE_PASSWORD = English.Settings.TEXT_CHANGE_PASSWORD,
    TEXT_PRIVACY_POLICY = English.Settings.TEXT_PRIVACY_POLICY,
    TEXT_CLOSE_ACCOUNT = English.Settings.TEXT_CLOSE_ACCOUNT,
    TEXT_ACCOUNT_INFO = English.Settings.TEXT_ACCOUNT_INFO,
    TEXT_GENERAL = English.Settings.TEXT_GENERAL,
    TEXT_NOTIFICATION_SETTINGS = English.Settings.TEXT_NOTIFICATION_SETTINGS,
    TEXT_TUTORIAL_VIDEOS = English.Settings.TEXT_TUTORIAL_VIDEOS
  } = LanguageData;

  const handelNotificationSettingModalOpen = () => {
    setNotificationModal(true);
  };

  const handelNotificationSettingModalClose = () => {
    setNotificationModal(false);
  };

  const handleLanguageChange = async (params) => {
    try {
      setIsLoading(true);
      const languageCode = params || "en";
      const appType = "Web";
      setLanguageCode(languageCode);
      const res = await Getrequestcall(
        `${GET_APP_LABELS_LANGUAGES_DETAILS}/${languageCode}/${appType}`,
        null
      );
      if (res?.status === 200 && res?.data?.message === "OK") {
        const toggleRes = await Getrequestcall(
          TOGGLE_USER_TRANSLATOR_MASSAGE,
          loginData?.accessToken
        );
        if (toggleRes?.status === 200) {
          // setIsSwitchOn(true);
          dispatch(
            setLogindata({
              ...loginData,
              // TranslateMessage: true,
              ChatLanguage: languageCode
            })
          );
        }
        dispatch(setMultiLanguageData(res.data.data));
        dispatch(setMultiLanguageCode(languageCode));
      }
      setOpenProcessModal(false);
      setLanguageSettingsModal(false);
      setIsLoading(false);
    } catch (error) {
      console.log("handleLanguageChange-> Error When Getting Changed Language Data: ", error);
      alert("Something Went Wrong When Getting Data, Please Try Again");
      setIsLoading(false);
      setOpenProcessModal(false);
      setLanguageSettingsModal(false);
    }
  };

  const renderListItems = (items) => {
    return items.map((item, i) => (
      <Card key={i} className="pagelist-content" sx={{ marginTop: "0px" }}>
        <ListItem
          key={i}
          secondaryAction={
            <Icon color="disabled">
              <ChevronRightIcon />
            </Icon>
          }
          disablePadding>
          <ListItemButton
            onClick={item?.onClick}
            href={item?.href}
            target={item?.target || "_self"}>
            <ListItemText primary={item.label} />
          </ListItemButton>
        </ListItem>
      </Card>
    ));
  };

  const sectionList = [
    {
      subheader: TEXT_GENERAL,
      items: [
        {
          label: TEXT_PRIVACY_POLICY,
          href: "https://www.iubenda.com/privacy-policy/90161377",
          target: "_blank"
        },
        {
          label: TEXT_TERMS_AND_CONDITIONS,
          href: "https://www.iubenda.com/terms-and-conditions/90161377",
          target: "_blank"
        }
      ]
    },
    {
      subheader: TEXT_ACCOUNT_INFO,
      items: [
        {
          label: TEXT_CHANGE_PASSWORD,
          onClick: () => setConfirmChangePasswordModal(true)
        },

        {
          label: TEXT_NOTIFICATION_SETTINGS,
          onClick: () => handelNotificationSettingModalOpen()
        },
        {
          label: TEXT_TUTORIAL_VIDEOS,
          onClick: () => {
            dispatch(setSelectedClientdata({}));
            dispatch(setSelectedAppPermissions([]));
            navigate("/tutorial-videos");
          }
        },
        {
          label: TEXT_LANGUAGE_SETTINGS,
          onClick: () => setLanguageSettingsModal(true)
        },
        {
          label: TEXT_CLOSE_ACCOUNT,
          onClick: () => navigate("/close-account")
        }
      ]
    }
  ];

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
      <Pageheader headerName={TEXT_SETTINGS} />
      <Card className="main-content-card" sx={{ pt: 0 }}>
        <Box className="main-content-card-list" sx={{ justifyContent: "space-between" }}>
          <Box>
            {sectionList.map((section, idx) => (
              <List
                disablePadding
                key={idx}
                subheader={<ListSubheader>{section.subheader}</ListSubheader>}>
                <Stack spacing={1}>{renderListItems(section.items)}</Stack>
              </List>
            ))}
          </Box>
          <Stack
            direction="column"
            sx={{ alignItems: "center", width: "100%", pt: 2 }}>
            {/* Logo above version */}
            <Stack direction="column" sx={{ alignItems: "center", mb: 0.5 }}>
              <Box sx={{ height: 50, display: "flex", alignItems: "center" }}>
                <img height="100%" src={BuildIdLogo} alt="Build ID" />
              </Box>
              <Box sx={{ fontSize: 12, fontWeight: 600, color: "#333", mt: 0.5 }}>
                v{packageJson.version}
              </Box>
            </Stack>
            <Box sx={{ mb: 1 }}>
              <Button
                variant="text"
                sx={{ fontWeight: "bold" }}
                onClick={() => setOpenSendFeedbackModal(true)}>
                {BUTTON_SEND_FEEDBACK}
              </Button>
            </Box>
            <Stack spacing={5} direction="row" sx={{ p: 1 }}>
              {socialIcons.map((icon, i) => (
                <Box key={i} sx={{ height: 35 }}>
                  <a href={icon.link} target="_blank" rel="noreferrer">
                    <Box
                      component="img"
                      src={icon.img}
                      alt={`social-${i}`}
                      height="100%"
                      sx={{
                        transition: "box-shadow 0.3s ease, transform 0.3s ease",
                        borderRadius: "7px",
                        "&:hover": {
                          boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.3)",
                          transform: "scale(1.05)"
                        }
                      }}
                    />
                  </a>
                </Box>
              ))}
            </Stack>
          </Stack>
        </Box>
      </Card>

      {languageSettingsModal && (
        <LanguageSettings
          open={languageSettingsModal}
          handleClose={() => setLanguageSettingsModal(false)}
          handleLanguageChange={handleLanguageChange}
          isLoading={isLoading}
          openProcessModal={openProcessModal}
          setOpenProcessModal={setOpenProcessModal}
          languageCode={languageCode}
          setLanguageCode={setLanguageCode}
        />
      )}

      {confirmChangePasswordModal && (
        <ChangePassword
          confirmChangePasswordModal={confirmChangePasswordModal}
          handleClose={() => setConfirmChangePasswordModal(false)}
        />
      )}

      {openSendFeedbackModal && (
        <SendFeedbackModal
          isOpen={openSendFeedbackModal}
          onClose={() => setOpenSendFeedbackModal(false)}
        />
      )}

      {notificationModal && (
        <NotificationSettingModal
          notificationModal={notificationModal}
          handelNotificationSettingModalClose={handelNotificationSettingModalClose}
        />
      )}
    </Box>
  );
}
